// src/utils/cookieConsent.js
const CONSENT_KEY = "cookieConsent";
const CONSENT_TIMESTAMP_KEY = "cookieConsentTimestamp";

/**
 * Get current cookie consent status
 * @returns {string|null} 'accepted', 'rejected', or null
 */
export const getCookieConsent = () => {
  if (typeof window === "undefined") return null;
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch (e) {
    console.error("Failed to read cookie consent:", e);
    return null;
  }
};

/**
 * Set cookie consent status
 * @param {string} value - 'accepted' or 'rejected'
 */
export const setCookieConsent = (value) => {
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem(CONSENT_KEY, value);
    localStorage.setItem(CONSENT_TIMESTAMP_KEY, new Date().toISOString());
    
    // Dispatch custom event for other parts of the app to listen to
    window.dispatchEvent(new CustomEvent('cookieConsentChanged', { 
      detail: { consent: value } 
    }));
  } catch (e) {
    console.error("Failed to save cookie consent:", e);
  }
};

/**
 * Clear cookie consent (for testing/reset purposes)
 */
export const clearCookieConsent = () => {
  if (typeof window === "undefined") return;
  try {
    localStorage.removeItem(CONSENT_KEY);
    localStorage.removeItem(CONSENT_TIMESTAMP_KEY);
  } catch (e) {
    console.error("Failed to clear cookie consent:", e);
  }
};

/**
 * Check if user has accepted cookies
 * @returns {boolean}
 */
export const hasConsent = () => {
  return getCookieConsent() === "accepted";
};

/**
 * Get consent timestamp
 * @returns {string|null} ISO timestamp or null
 */
export const getConsentTimestamp = () => {
  if (typeof window === "undefined") return null;
  try {
    return localStorage.getItem(CONSENT_TIMESTAMP_KEY);
  } catch (e) {
    console.error("Failed to read consent timestamp:", e);
    return null;
  }
};